module.exports = __webpack_public_path__ + "static/media/molly2.f0cf6092.png";